import { isTottusStandalone } from '@digital-retail/store-manager';
import PropTypes from 'prop-types';
import React from 'react';
import { storeMap } from '../../config/storeMap';
import { checkPLPSeoFilters } from '../../utils/CheckPLPSeoFilters';
import { BodyCopy } from '../ui/BodyCopy/BodyCopy';
import { CategoryTitleStyles } from './CategoryTitle.style';

export const CategoryTitle = ({
  level1Category,
  level2Category = {},
  appCtx,
  appliedFacets,
  resultsLabel,
  paginationCount,
  breadCrumbData,
}) => {
  let level1CategoryURL = '#';
  const { label = '' } = level2Category;
  let path = appCtx.tenant;
  const isTottus = isTottusStandalone(appCtx.store);
  if (appCtx.store && appCtx.store !== 'tienda') {
    path = `${storeMap[appCtx.store]}-${appCtx.regionCode}`;
    if (path === 'aldo-pe') {
      path = 'aldoshoes-pe';
    }
  }
  if (level1Category && !level1Category.isRoot) {
    level1CategoryURL = `/${path}${level1Category.link}`;
  }

  const labelComplement = checkPLPSeoFilters(appliedFacets);
  const l2CatgeoryLabel = `${label} ${labelComplement}`;
  const isMobile = appCtx.deviceType === 'mobile';

  return (
    <div className={`categoty-title-container ${isMobile ? 'mobile' : ''}`} id="testId-CategoryTitle-container">
      {appCtx.deviceType === 'desktop' && (
        <a className="l1category" href={level1CategoryURL}>
          {level1Category &&
            React.createElement(isTottus && breadCrumbData.length === 1 ? 'h1' : 'h2', null, level1Category.label)}
        </a>
      )}
      {(!isTottus || (breadCrumbData.length > 1 && l2CatgeoryLabel && String(l2CatgeoryLabel).trim().length > 0)) && (
        <BodyCopy size="copy10" type="primary" isHighlighted={!isMobile} light={isMobile}>
          <h1 className="l2category" title={l2CatgeoryLabel}>
            {l2CatgeoryLabel}
          </h1>
        </BodyCopy>
      )}
      {isMobile && (
        <BodyCopy size="copy5" id="testId-ProductLandingContainer-totalResults" type="secondary">
          {resultsLabel} ({paginationCount})
        </BodyCopy>
      )}
      <style jsx>{CategoryTitleStyles}</style>
    </div>
  );
};

CategoryTitle.defaultProps = {
  appliedFacets: [],
  resultsLabel: '',
  breadCrumbData: [],
};

CategoryTitle.propTypes = {
  level1Category: PropTypes.object.isRequired,
  level2Category: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  appliedFacets: PropTypes.array,
  resultsLabel: PropTypes.string,
  paginationCount: PropTypes.string.isRequired,
  breadCrumbData: PropTypes.arrayOf(PropTypes.object),
};
